export default {
  open_standalone: 'Open',
  closed_standalone: 'Closed',

  open: 'Open',
  closed: 'Closed',
  opening: 'Opens',
  closing: 'Closes',
  yes_we_are: "Yes, we're",
  sorry_we_are: "Sorry, we're",
  twentyfourseven: '24/7',
  closing_tomorrow: 'Closes tomorrow',
  opening_tomorrow: 'Opens tomorrow',
  at_x: '%x%',
  closing_x: 'Closes %x%',
  opening_x: 'Opens %x%',

  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',

  businessHours: 'Business Hours'
};



// WEBPACK FOOTER //
// ./src/commons/translations/en.js